export default {
  name: 'oLight'
};
